var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg18PxNewspaper = function Svg18PxNewspaper(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#56565C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M3.5 16.25a1.75 1.75 0 0 1-1.75-1.75v-4.25a.5.5 0 0 1 .5-.5h.5M5.25 14.5a1.75 1.75 0 0 1-1.75 1.75h10.75a2 2 0 0 0 2-2V3.75a2 2 0 0 0-2-2h-7a2 2 0 0 0-2 2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#56565C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M13.25 4.75h-5v2.5h5zM13.25 10.25h-5M13.25 13.25h-5"
  })));
};
export default Svg18PxNewspaper;